const DEFAULT_ONLYPAY_PHONES = new Set([
  '011999999999',
  '11999999999',
  '011981710193',
  '11981710193',
  '01138424693',
  '1138424693'
]);

export function phoneDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function composePhone(telefones = {}) {
  return `${telefones.ddd || ''}${telefones.numeroTelefone || ''}`;
}

export function isDefaultOnlyPayPhone(value) {
  let digits = phoneDigits(value);
  if (!digits) return false;

  if (digits.startsWith('55') && digits.length >= 12) {
    digits = digits.slice(2);
  }

  const withZero = digits.startsWith('0') ? digits : `0${digits}`;
  const withoutZero = digits.startsWith('0') ? digits.slice(1) : digits;

  return (
    DEFAULT_ONLYPAY_PHONES.has(digits)
    || DEFAULT_ONLYPAY_PHONES.has(withZero)
    || DEFAULT_ONLYPAY_PHONES.has(withoutZero)
  );
}
